import { AppThunkAction } from "..";
import {
    KnownAction,
    GET_ACCOUNT_INFORMATION_LOADER,
    SET_IS_IDF_USER_LOADER,
    GET_IS_IDF_USER,
    SET_FAMILY_OFFER_LOADER,
    GET_FAMILY_OFFER,
    SET_IS_BILLING_INFO_CHANGED,
} from "./types";
import { BusinessNameAction, SET_USER_FIRSTNAME_AND_LASTNAME, KnownAction as LoginAction } from "../loginService/types";
import * as httpClient from "../../util/httpClient";
import { decodeData } from "../../util/common";

export const actionCreators = {
    getAccountInformation:
        (forceReload?: boolean, response?: any): AppThunkAction<KnownAction | BusinessNameAction | LoginAction> =>
        (dispatch, getState) => {
            let state = getState();

            if (state != null && state.myAccountServiceState != null && (state.myAccountServiceState._unifiedAccountInfo == null || forceReload === true)) {
                dispatch({ type: GET_ACCOUNT_INFORMATION_LOADER, isLoading: true });
                // used to create state in Login.tsx where API is called outside of actionCreators
                if (response ? !!!response._unifiedAccountInfo._personalAccountInformation.primaryEmail : !response) {
                    httpClient
                        .sendRequest("GET", "api/accountInfo/getAccountInformation")
                        .then((data) => {
                            getDispatchAccountInformation(dispatch, getState, data);
                        })
                        .catch(function (error) {
                            dispatch({ type: GET_ACCOUNT_INFORMATION_LOADER, isLoading: false });
                        });
                } else {
                    getDispatchAccountInformation(dispatch, getState, response);
                }
            }
        },
    getSecurityQuestions: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const state = getState();
        let userdata: any = {
            email: "",
            isIDFUser: false,
            isSuccess: true,
            securityQuestionsCount: 3,
            portalName: "",
            isLanguageSupport: "true"
        };
        if (state.configurationState && state.configurationState.configuration && state.configurationState.configuration.partnerConfig != null) {
            userdata.portalName = state.configurationState.configuration.partnerConfig.partnerProvider;
        }

        if (state.loggedInUser && state.loggedInUser.userInfo) {
            userdata.email = state.loggedInUser?.userInfo?.EmailAddress;
        }
        if (state.csidUserStatusState && state.csidUserStatusState.csidUserStatus) {
            userdata.isIDFUser = state.csidUserStatusState.csidUserStatus.isIDFUser;
        }

        if (userdata.email && userdata.portalName) {
            dispatch({ type: GET_ACCOUNT_INFORMATION_LOADER, isLoading: true });
            httpClient
                .sendRequest("POST", "api/security-question/get-security-questions", userdata)
                .then((data) => {
                    if (data && data.hasError === false) {
                        dispatch({ type: "GET_SECURITY_QUESTIONS", securityQueData: data });
                    }
                })
                .catch(function (error) {});
        }
    },
    GetIsIdfUser: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const state = getState();

        if (
            state != null &&
            state.myAccountServiceState != null &&
            state.myAccountServiceState.isIdfUser == null &&
            state.myAccountServiceState.isIdfUserLoading === false
        ) {
            dispatch({ type: SET_IS_IDF_USER_LOADER, isIdfUserLoading: true });
            httpClient
                .sendRequest("GET", `web/user/is-idf-user`)
                .then((data) => {
                    dispatch({ type: SET_IS_IDF_USER_LOADER, isIdfUserLoading: false });

                    if (data) {
                        dispatch({ type: GET_IS_IDF_USER, isIdfUser: Boolean(data) });
                    }
                })
                .catch(function (error) {
                    dispatch({ type: SET_IS_IDF_USER_LOADER, isIdfUserLoading: false });
                });
        }
    },
    GetFamilyOffer:
        (reload?: boolean): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            const state = getState();

            if (
                state != null &&
                state.myAccountServiceState != null &&
                state.myAccountServiceState.isLoadingFamilyOffer === false &&
                (reload || !state.myAccountServiceState.familtOffer)
            ) {
                dispatch({ type: SET_FAMILY_OFFER_LOADER, isLoadingFamilyOffer: true });
                httpClient
                    .sendRequest("GET", `api/family/GetFamilyOffer`)
                    .then((data) => {
                        dispatch({ type: SET_FAMILY_OFFER_LOADER, isLoadingFamilyOffer: false });

                        if (data) {
                            dispatch({ type: GET_FAMILY_OFFER, familyOffer: data });
                        }
                    })
                    .catch(function (error) {
                        dispatch({ type: SET_FAMILY_OFFER_LOADER, isLoadingFamilyOffer: false });
                    });
            }
        },
    SetIsBillingInfoChangedStatus:
        (status: boolean): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            dispatch({ type: SET_IS_BILLING_INFO_CHANGED, isBillingInfoChanged: status ? status : false });
        },
};
export function getDispatchAccountInformation(dispatch: any, state: any, response: any) {
    dispatch({ type: GET_ACCOUNT_INFORMATION_LOADER, isLoading: false });
    if (response && response.hasError === false) {
        // delete unsafe pii from store
        let temData = response._unifiedAccountInfo;
        delete temData.memberShipNumber;
        delete temData.idfUserId;
        delete temData.ein;
        delete temData._businessInformation.ein;

        dispatch({ type: "GET_ACCOUNT_INFORMATION", _unifiedAccountInfo: decodeData(response._unifiedAccountInfo) });
        dispatch({ type: "SET_BUSINESS_NAME", businessName: response._unifiedAccountInfo?._businessInformation?.businessName });
        const unifiedAccountInfo = decodeData(response._unifiedAccountInfo);
        const isPrimaryAccount: boolean =
            state &&
            state.loggedInUser &&
            state.loggedInUser.activeAccount &&
            state.loggedInUser.activeAccount.accountType &&
            state.loggedInUser.activeAccount.accountType === "PRIMARY"
                ? true
                : false;
        if (
            isPrimaryAccount &&
            unifiedAccountInfo &&
            unifiedAccountInfo._personalAccountInformation &&
            unifiedAccountInfo._personalAccountInformation.firstName &&
            unifiedAccountInfo._personalAccountInformation.lastName
        ) {
            dispatch({
                type: SET_USER_FIRSTNAME_AND_LASTNAME,
                userInformation: {
                    firstName: unifiedAccountInfo._personalAccountInformation.firstName,
                    lastName: unifiedAccountInfo._personalAccountInformation.lastName,
                },
            });
            const userInfo = state && state.loggedInUser && state.loggedInUser.userInfo;
            if (userInfo) {
                userInfo.primaryPhone =
                    unifiedAccountInfo && unifiedAccountInfo._personalAccountInformation && unifiedAccountInfo._personalAccountInformation.primaryPhone;
                userInfo.firstName = unifiedAccountInfo._personalAccountInformation.firstName;
                userInfo.lastName = unifiedAccountInfo._personalAccountInformation.lastName;
                userInfo.loginUserName = unifiedAccountInfo._personalAccountInformation.userName;
                dispatch({ type: "SUBMIT_LOGIN", userInfo: userInfo });
            }
        }
    }
}
